import { call, put, takeEvery } from 'redux-saga/effects';
import { golfApi } from 'config/axios';
import { toQueryString } from 'utils/UrlUtil';

import {
    FETCH_GOLF_HISTORICAL_SHOTS,
    FETCH_GOLF_HISTORICAL_SHOTS_FETCHING,
    FETCH_GOLF_HISTORICAL_SHOTS_SUCCESS,
    FETCH_GOLF_HISTORICAL_SHOTS_FAIL
} from 'actions/golfShotsActionTypes';

export function* fetchGolfHistoricalShotsSaga(action) {
    try {
        yield put({
            type: FETCH_GOLF_HISTORICAL_SHOTS_FETCHING
        });

        const queryString = toQueryString({
            'image-size': 'IMG_730X730',
            'skip-club-detail-info': true
        });

        const url = `/gcs-golfcommunity/api/v2/shot/course-snapshot/${action.courseId}/hole${queryString}`;

        const response = yield call(golfApi.get, url);

        yield put({
            type: FETCH_GOLF_HISTORICAL_SHOTS_SUCCESS,
            historicalShots: response.data,
            courseId: action.courseId
        });
    } catch (e) {
        yield put({
            type: FETCH_GOLF_HISTORICAL_SHOTS_FAIL,
            historicalShots: {},
            courseId: action.courseId
        });
    }
}

export const golfHistoricalShots = [takeEvery(FETCH_GOLF_HISTORICAL_SHOTS, fetchGolfHistoricalShotsSaga)];
